import React, { useState } from 'react';
import classes from './pages.module.css';
import TextCol from "../components/Ui/text/textCol";
import TextList from '../components/Ui/text/textList';
import ImgList from '../components/Ui/img/imgList';
import imgblock9 from '../image/image9.png';
import imgblock10 from '../image/image10.png';
import imgblock11 from '../image/image11.png';
import imgblock12 from '../image/image12.png';
import imgblock13 from '../image/image13.png';
import imgblock14 from '../image/image14.png';
import imgblock15 from '../image/image15.jpeg';
import imgblock16 from '../image/image16.jpeg';
import OptionList4 from '../components/Ui/block/optionList4';
import iconDoc from '../image/icondoc.png';
import icon21 from '../image/icon21.png';
import icon22 from '../image/icon22.png';
import icon23 from '../image/icon23.png';
import icon24 from '../image/icon24.png';
import icon25 from '../image/icon25.png';
import icon26 from '../image/icon26.png';
import icon27 from '../image/icon27.png';

const Dicecell = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Спроектирован в виде модулей'},
        {id:2, content: 'В элементах конструкции можно разместить рекламную графику, светодиодные и тач. панели для показа рекламы и рекламного контента'},
        {id:3, content: 'Организован по функциональному назначению и связан общей инженерной инфраструктурой и ПО управления. Спроектирован как микро ЦОД'},
        {id:4, content: 'Подходит для внутреннего и внешнего исполнения'},
        {id:5, content: 'Полностью обеспечивает физическую реализацию международных стандартов по управлению ITIL (Information Technology Infrastructure Library) и управление инфраструктурой (ISO 41000)'},
        {id:6, content: 'Возможность размещения видеонаблюдения, громкоговорителя, USB, зарядки для автомобилей, сейфы, системы управления уличным освещением,Wi-Fi, 5G, IoT, медицинские ячейки, билетные сервисы, банкоматы'},
    ])
    const [posts, setPosts] = useState([
        {id:1, body: 'Привлекательный дизайн в городской экосистеме;' },
        {id:2, body: 'Коммерциализация башенного хозяйства (суб-аренда, разграничение доступа);' },
        {id:3, body: 'Интеграция с платежными и внешними системами (торговые терминалы);' },
        {id:4, body: 'Организация площадок под рекламу с различными формами предоставления контента;' },
        {id:5, body: 'Бесшовная интеграция с системами BIM (информационными системами управления недвижимым имуществом).' },
    ])
    const [imgblocks, setimgblocks] = useState([
        {id:1, title: 'Городские службы', img: (imgblock9)},
        {id:2, title: 'Операторы связи', img: (imgblock10)},
        {id:3, title: 'Аэропорты', img: (imgblock11)},
        {id:4, title: 'Стадионы, парки', img: (imgblock12)},
        {id:5, title: 'Торговые сети', img: (imgblock13)},
        {id:6, title: 'Сервисы доставки', img: (imgblock14)},
        {id:7, title: 'Рекламные агентства', img: (imgblock15)},
        {id:8, title: 'Контент провайдеры и платежные системы', img: (imgblock16)},
    ])
    const [options, setOptions] = useState([
        {id:1, title: 'Документация', src: (iconDoc), body: 'Централизованное ведение документации всего башенного хозяйства.' },
        {id:2, title: 'Оптимизация расходов', src: (icon21), body: 'Оптимизация расходов на эксплуатацию за счет применения централизованных систем управления.' },
        {id:3, title: 'Гибкая кастомизация', src: (icon22), body: 'Гибкая кастомизация под различные бизнес модели, которая конфигурируется с «мультизадачным» разделением ресурсов.' },
        {id:4, title: 'Управление', src: (icon23), body: 'Управление башнями как виртуализированными ресурсами, включая организацию и инвентаризацию конфигураций, монтируемого оборудования, реализацию бизнес моделей по аренде ресурсов.' },
        {id:5, title: 'Вариативность действий ', src: (icon24), body: 'Использование средств разделенного мониторинга, планирования, управления контентом и размещенным внутри DICECEL оборудованием.' },
        {id:6, title: 'Стандартизированное взаимодействие', src: (icon25), body: 'Использование стандартизированных интерфейсов взаимодействия через WEB или коннекторы интерфейсов для всех функциональных пользователей инфраструктуры.' },
        {id:7, title: 'Разделяемые работы', src: (icon26), body: 'Организация разделяемых регламентных работ на изолированных друг от друга модулях, что снижает стоимость обслуживания и исключает инциденты, связанные с вмешательством в другие установленные на конструкции подсистемы.' },
        {id:8, title: 'Высокотехнологичные интеграции', src: (icon27), body: 'Функционирование инфраструктуры 5G, умных городов, Интернета вещей с поддержкой визуализации медиа-контента, систем городской безопасности, организации общественных зон доступа к умной инфраструктуре, таких как Wi-Fi, станции подзарядки, мест отдыха и прочих услуг.' },
    ])


    return (
        <>
            <div className={classes.topBlock_small}>
                <div className={classes.top_content}>
                    <h1>DICECELL</h1>
                    <div className={classes.devider}></div>
                    <p>Дизайнерская башня для размещения обслуживающих людей технологий и справочной информации. Внешний вид и размещаемые технологии полностью настраиваются. Создано для вашего удобства.<br></br><br></br>
                        Модульный DICECELL идеально подходит как для улиц, так и для помещений, поддерживает различные технологии подключения — сотовых операторов, 5G, IoT, Wi-Fi — и обеспечивает интеграцию с широким спектром надстроек: уличное освещение, зарядные устройства для электромобилей и смартфонов, сейфы, реклама, информационно-развлекательный дисплеи, билетные сервисы и т. д.
                        Высота исполнения конструкции 4-12 метров.
                    </p>
                </div>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} title="ОСОБЕННОСТИ DICECELL" />
            <TextList posts={posts} title="ВОЗМОЖНОСТИ DICECELL"/>
            <ImgList imgblocks={imgblocks} title="ДЛЯ КОГО"/>
            <OptionList4 options={options} title="Основные особенности и преимущества " />
        </>
    )
}

export default Dicecell;